import {
  Phone,
  Mail,
  Download,
  MapPin,
  Truck,
  MessageCircle,
  ShoppingBag,
} from "lucide-react";
import { Button } from "./ui/button";
import { Link } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import { WHATSAPP_URL, SHOP_URL } from "../lib/i18n";

export function TopBar() {
  const { t } = useLang();
  return (
    <div className="hidden md:block bg-gradient-to-r from-cyan-50 via-white to-red-50/40 text-slate-700 text-[11px] border-b border-slate-200" data-testid="top-bar">
      <div className="max-w-[1400px] mx-auto px-4 lg:px-8 h-9 flex items-center justify-between">
        <div className="flex items-center gap-5">
          <span className="flex items-center gap-1.5 text-slate-600">
            <Truck className="w-3.5 h-3.5 text-[#ef4444]" />
            {t.topBar.delivery}
          </span>
        </div>
        <div className="flex items-center gap-5">
          <a href="tel:+97142882777" data-testid="topbar-phone" className="flex items-center gap-1.5 text-slate-600 hover:text-[#0891b2] transition-colors">
            <Phone className="w-3.5 h-3.5" />
            <span dir="ltr">+971 4-288-2777</span>
          </a>
          <a href="mailto:admin@mariotkitchen.com" data-testid="topbar-email" className="hidden lg:flex items-center gap-1.5 text-slate-600 hover:text-[#0891b2] transition-colors">
            <Mail className="w-3.5 h-3.5" />
            <span dir="ltr">admin@mariotkitchen.com</span>
          </a>
          <a
            href={`${WHATSAPP_URL}?text=${encodeURIComponent(t.topBar.catalogueMsg)}`}
            target="_blank"
            rel="noreferrer"
            data-testid="topbar-catalogue"
            className="flex items-center gap-1.5 text-[#ef4444] hover:text-[#dc2626] transition-colors font-medium"
          >
            <Download className="w-3.5 h-3.5" />
            {t.topBar.catalogue}
          </a>
          <Link to="/branches" data-testid="topbar-branches" className="hidden lg:flex items-center gap-1.5 text-slate-600 hover:text-[#0891b2] transition-colors">
            <MapPin className="w-3.5 h-3.5" />
            {t.topBar.branches}
          </Link>


          <a
  href={WHATSAPP_URL}
  target="_blank"
  rel="noreferrer"
  className="flex items-center gap-1 bg-green-600 hover:bg-green-700 text-white px-3 py-1 rounded text-[11px] font-medium transition-colors"
>
  <MessageCircle className="w-3 h-3" />
  WhatsApp
</a>

<a
  href={SHOP_URL}
  target="_blank"
  rel="noreferrer"
  className="flex items-center gap-1 bg-slate-700 hover:bg-slate-900 text-white px-3 py-1 rounded text-[11px] font-medium transition-colors"
>
  <ShoppingBag className="w-3 h-3" />
  {t.nav.shop}
</a>

<Link to="/quote">
  <Button
    size="sm"
    className="bg-red-500 hover:bg-red-600 text-white h-7 px-3 text-[11px]"
  >
    {t.nav.quote}
  </Button>
</Link>



        </div>
      </div>
    </div>
  );
}
